import {useApi} from "../Api";
import {Location} from "../types/location";

export const useLocationRepository = () => {
    const {GET, POST, PUT} = useApi();

    const PATH = "/pricing/location";

    function getLocationAll(): Promise<Location[]> {
        return GET(`${PATH}/list`);
    }

    function postLocationAll(locations: Location[]): Promise<Location[]> {
        return POST(`${PATH}/full`, locations);
    }

    function putLocationAll(locations: Location[]): Promise<Location[]> {
        return PUT(`${PATH}/full`, locations);
    }

    function getLocationAllFiltered(legalEntites:string): Promise<Location[]> {
        return GET(`${PATH}/filter?legalEntities=${legalEntites}`);
    }

    return {
        getLocationAll,
        postLocationAll,
        putLocationAll,
        getLocationAllFiltered
    };
};